<template>
  <hm-content title="">
    <div class="mb10 flex flex-end">
      <el-select size="small" class="mr10" v-model="searchCondition.examId">
        <el-option
          :label="v.name"
          :value="v.examId"
          v-for="(v, i) in typeList"
          :key="i"
        ></el-option>
      </el-select>
      <el-date-picker
        v-model="searchCondition.applyDate"
        type="datetimerange"
        align="right"
        start-placeholder="请选择时间段"
        end-placeholder="请选择时间段"
        value-format="yyyy-MM-dd HH:mm:ss"
        :default-time="['00:00:00', '23:59:59']"
        size="small"
        class="mr10 time"
      ></el-date-picker>
      <el-input
        clearable
        style="width:300px"
        v-model.trim="searchCondition.queryMemberValue"
        placeholder="请输入"
        size="small"
        class="ipt mr10"
      >
        <el-select
          slot="prepend"
          size="small"
          style="width:100px"
          v-model="searchCondition.queryMemberType"
        >
          <el-option label="手机号" value="memberMobile"></el-option>
          <el-option label="姓名" value="memberName"></el-option>
        </el-select>
      </el-input>
      <el-button type="primary" size="small" @click="search">查询</el-button>
      <el-button type="success" size="small" @click="output">导出</el-button>
    </div>
    <div class="mb10">
      <el-radio-group
        v-model="searchCondition.examineStates"
        size="small"
        @change="switchTab"
      >
        <el-radio-button label="">全部</el-radio-button>
        <el-radio-button label="waitAudit">待审核</el-radio-button>
        <el-radio-button label="success">已通过</el-radio-button>
        <el-radio-button label="rejected">已驳回</el-radio-button>
      </el-radio-group>
    </div>
    <div class="table">
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="examineType"
          label="审核类型"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberMobile"
          label="手机号"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberName"
          label="姓名"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="examineContent"
          label="内容"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="applyTime"
          label="申请时间"
        >
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="examineStatesStr"
          label="状态"
        >
          <template slot-scope="scope">
            <div :class="scope.row.examineStates">
              {{ scope.row.examineStatesStr }}

            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          width="200"
        >
          <template slot-scope="scope">
            <div class="flex flex-center item-center">
              <el-button
                type="text"
                size="small"
                class="blue"
                @click="openFrom(scope.row)"
                v-if="scope.row.examineType === '申请成为推会员'"
              >
                表单信息
              </el-button>
              <div v-else class="gray" style="width:50px">
                -- --
              </div>
              <el-divider direction="vertical"></el-divider>
              <el-button
                type="text"
                size="small"
                class="blue"
                v-if="scope.row.isCanAudit || scope.row.examineStates === 'rejected' "
                @click="status(scope.row)"
              >
                审核
              </el-button>
              <div v-else class="gray" style="width:26px">
                -- --
              </div>

              <el-divider direction="vertical"></el-divider>
              <el-button
                type="text"
                size="small"
                class="blue"
                @click="records(scope.row)"
              >
                操作记录
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      width="700px"
      :visible.sync="dialogVisible"
    >
      <div class="flex" v-if="type === 'audit'">
        <div class="mr10 mt10">
          备注
        </div>
        <el-input
          style="width:380px"
          size="small"
          clearable
          type="textarea"
          :rows="5"
          :cols="45"
          placeholder="请输入审核备注"
          v-model.trim="remark"
        ></el-input>
      </div>
      <div v-else>
        <el-table
          stripe
          border
          ref="table"
          :data="operationList"
          style="width: 100%"
          id="table"
          size="small"
        >
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="examineStatesZh"
            label="操作类型"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="statusTime"
            label="操作时间"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="realname"
            label="审核人"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="remark"
            label="备注"
          >
          </el-table-column>
        </el-table>
      </div>

      <div
        slot="footer"
        class="dialog-footer flex flex-center mt20"
        v-if="type === 'audit'"
      >
        <el-button
          type="success"
          size="small"
          @click="operateExamine('success')"
        >
          通过</el-button
        >
        <el-button type="danger" size="small" @click="operateExamine('reject')">
          驳回</el-button
        >
      </div>
      <div slot="footer" class="dialog-footer flex flex-center mt20" v-else>
        <el-button type="primary" size="small" @click="dialogVisible = false">
          确认</el-button
        >
        <el-button type="info" size="small" @click="dialogVisible = false">
          取消</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="表单信息"
      width="500px"
      :visible.sync="dialogVisibleFrom"
    >
      <el-table
        stripe
        ref="table"
        :data="fromList"
        style="width: 100%"
        :show-header="false"
        id="table"
        size="small"
        border
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="right"
          prop="columnName"
          width="100"
        >
          <template slot-scope="scope">
            {{ scope.row.columnName + ":" }}
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="left" prop="statusTime">
          <template slot-scope="scope">
            {{ scope.row.inputValue }}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <div v-if="redPackageDialogVisible">
      <el-dialog
        :title="title"
        width="800px"
        :close-on-click-modal="false"
        :visible.sync="redPackageDialogVisible"
      >
        <HmRedPacgageAudit
          :auditType="redPacgageAuditType"
          :id="queryId"
          :formPath="'audit'"
          ref="rpAudit"
        ></HmRedPacgageAudit>
        <div slot="footer" class="dialog-footer flex flex-center mt20">
          <el-button type="primary" size="small" @click="redPackageAudit">
            确认</el-button
          >
          <el-button
            type="info"
            size="small"
            @click="redPackageDialogVisible = false"
          >
            取消</el-button
          >
        </div>
      </el-dialog>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      width="1000px"
      :visible.sync="dialogVisibleCard"
    >
      <div>
        <el-dialog
          width="30%"
          title="审核备注"
          :visible.sync="innerVisible"
          append-to-body
        >
          <el-form label-width="90px">
            <el-form-item label="审核备注：">
              <el-input
                maxlength="100"
                placeholder="请输入审核备注"
                size="small"
                style="width: auto"
                :autosize="{ minRows: 4 }"
                type="textarea"
                v-model="remark"
              ></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer flex flex-center">
            <el-button
              @click="operateExamine('success')"
              size="small"
              type="primary"
              v-if="auditStatus === 'agree'"
              >通 过</el-button
            >
            <el-button
              @click="operateExamine('reject')"
              size="small"
              type="danger"
              v-if="auditStatus === 'refuse'"
              >驳 回</el-button
            >

            <el-button @click="innerVisible = false" size="small"
              >取 消</el-button
            >
          </span>
        </el-dialog>
        <ul class="info-list">
          <li class="mb20">
            <div class="title">
              基本规则
            </div>
            <div class="modal-table mb20">
              <div class="table-header flex">
                <!-- <div class="flex-1">匹配信息</div> -->
                <div class="flex-1">储值卡名称</div>
                <div class="flex-1">卡样式</div>
                <div class="flex-1">储值卡售价</div>
                <div class="flex-1">发售数量</div>
                <div class="flex-1">储值卡面值</div>
              </div>
              <div class="table-body flex item-center">
                <!-- <div class="flex-1">
                      {{}}
                    </div> -->
                <div class="flex-1">
                  {{ details.cardName }}
                </div>
                <div class="flex-1">
                  <el-image
                    style="width:100px; height:40px"
                    :src="details.cardBgp"
                    :preview-src-list="[details.cardBgp]"
                  >
                  </el-image>
                </div>
                <div class="flex-1">
                  <span class="primary"> {{ details.cardSalePrice }}元 </span>
                </div>
                <div class="flex-1">
                  {{ details.stockNum }}
                </div>
                <div class="flex-1">
                  <span class="primary">
                    {{ details.cardDenomination }}元
                  </span>
                </div>
              </div>
            </div>
          </li>
          <li class="mb20">
            <div class="title">
              使用规则
            </div>
            <div style="margin:10px 0;color:#222">
              <div>
                使用时段:
                <span v-if="details.validMode === 'now'"
                  >即买即用,购买后{{ details.validDuration }}月过期。</span
                >
                <span v-if="details.validMode === 'range'"
                  >限时使用,{{ details.validStartTime }}至{{
                    details.validEndTime
                  }}</span
                >
              </div>
            </div>
            <div style="margin-bottom:5px;color:#222">
              商品限制
            </div>
            <el-table
              stripe
              v-if="details.prepayGoodsList.length"
              ref="brandTable"
              class="mb20 modal-table"
              :header-cell-style="{ background: ' #f7f7f7', color: '#222' }"
              :data="details.prepayGoodsList"
              style="width: 100%"
              id="table"
              size="small"
            >
              <el-table-column
                type="index"
                label="序号"
                header-align="center"
                align="center"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="attrId"
                label="商品Id"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="attrValue"
                label="商品名称"
              ></el-table-column>
              <!-- <el-table-column
                    header-align="center"
                    align="center"
                    prop="attrType"
                    label="类型"
                  ></el-table-column> -->
            </el-table>
            <div v-else>
              不限商品
            </div>
          </li>
        </ul>
        <span slot="footer" class="dialog-footer flex flex-center">
          <el-button
            @click="openRemark('agree')"
            size="small"
            type="primary"
            v-if="details.auditStatus === 'wait' || details.auditStatus === 'refuse'"
            >通 过</el-button
          >
          <el-button
            @click="openRemark('refuse')"
            size="small"
            type="danger"
            v-if="details.auditStatus === 'wait' || details.auditStatus === 'refuse'"
            >驳 回</el-button
          >

          <el-button @click="dialogVisibleCard = false" size="small" v-else
            >取 消</el-button
          >
        </span>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import HmRedPacgageAudit from "@/components/HmRedPacgageAudit";
export default {
  components: { HmRedPacgageAudit },
  data() {
    return {
      innerVisible: false,
      details: {
        prepayGoodsList: []
      },
      row: {},
      dialogVisibleCard: false,
      fromList: [],
      dialogVisibleFrom: false,
      typeList: [],
      operationList: [],
      remark: "",
      type: "audit",
      title: "代理商审批",
      dialogVisible: false,
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {
        examineStates: "",
        queryMemberType: "memberMobile",
        queryMemberValue: "",
        examId: ""
      },
      redPackageDialogVisible: false,
      redPacgageAuditType: "agent",
      queryId: "",
      auditStatus: "",
      initStoreCode: ""
    };
  },
  created() {},
  mounted() {
    this.queryList();
    this.queryExamineConfig();
  },
  methods: {
    openRemark(auditStatus) {
      this.innerVisible = true;
      this.auditStatus = auditStatus;
    },
    //红包审核
    redPackageAudit() {
      if (this.$refs.rpAudit.auditData.status == "yes") {
        this.initStoreCode = this.$refs.rpAudit.dataInfo.storeCode;
        this.operateExamine("success");
      } else {
        this.remark = this.$refs.rpAudit.auditData.desc;
        this.operateExamine("reject");
      }
    },
    openFrom(row) {
      this.row = row;
      this.queryShareRuleDynamicFormInputRecord();
    },
    async queryShareRuleDynamicFormInputRecord() {
      const { result } = await this.$store.dispatch(
        "queryShareRuleDynamicFormInputRecord",
        {
          storeCode: this.row.storeCode,
          centerId: this.row.centerId
        }
      );
      if (!result.length) {
        this.$message({
          message: "无表单信息",
          type: "warning"
        });
        return;
      }
      this.fromList = result;
      this.dialogVisibleFrom = true;
    },
    async queryExamineConfig() {
      const { result } = await this.$store.dispatch("queryExamineConfig");
      this.typeList = [];
      this.typeList = result.map(v => {
        return {
          name: v.examineType,
          examId: v.id
        };
      });
      this.typeList.unshift({
        name: "全部",
        examId: ""
      });
    },
    records(row) {
      this.row = row;
      this.queryExamineStatusRecordList();
    },
    async queryExamineStatusRecordList() {
      const { result } = await this.$store.dispatch(
        "queryExamineStatusRecordList",
        {
          id: this.row.id
        }
      );

      if (result.length) {
        this.title = "操作记录";
        this.type = "records";
        this.dialogVisible = true;
        this.operationList = result;
      } else {
        this.$message({
          message: "暂无操作记录",
          type: "warning"
        });
      }
      console.log("result: ", result);
    },
    async operateExamine(operateStates) {
      let params = JSON.parse(JSON.stringify(this.row));
      params.operateStates = operateStates;
      params.remark = this.remark;
      await this.$store.dispatch("operateExamine", params);
      this.$message({
        message: "操作成功！",
        type: "success"
      });
      this.dialogVisible = false;
      this.redPackageDialogVisible = false;
      this.dialogVisibleCard = false;
      this.innerVisible = false;
      this.queryList();
      if (
        "success" == operateStates &&
        this.row.examineType == "代理商身份认证"
      ) {
        this.initStoreData();
      }
    },
    async initStoreData() {
      let params = {
        storeCode: this.initStoreCode
      };
      this.$store.dispatch("initStoreData", params);
    },
    status(row) {
      this.type = "audit";
      this.row = row;
      this.queryId = row.id;
      if (row.examineType == "代理商身份认证") {
        this.title = "代理商审批";
        this.redPacgageAuditType = "agent";
        this.redPackageDialogVisible = true;
        return;
      }
      if (row.examineType == "供货商身份认证") {
        this.title = "供货商审批";
        this.redPacgageAuditType = "supplier";
        this.redPackageDialogVisible = true;
        return;
      }
      if (row.examineType == "储值卡审核") {
        this.title = "储值卡审核";
        // this.redPacgageAuditType = "supplier";
        this.queryPrepayCardDetails();

        return;
      }
      this.title = "审核";
      this.dialogVisible = true;
    },
    async queryPrepayCardDetails() {
      const { result } = await this.$store.dispatch("detailPrepayCard", {
        cardId: this.row.changeValueId
      });
      this.details = result;
      this.dialogVisibleCard = true;
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    output() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.queryStartTime = this.isArray(searchCondition.applyDate)
          ? searchCondition.applyDate[0]
          : "";
      searchCondition.queryEndTime = this.isArray(searchCondition.applyDate)
          ? searchCondition.applyDate[1]
          : "";
      Object.assign(params, searchCondition);
      const { code, result } = this.$store.dispatch(
          "storeExamineListExport",
          params
      );
      setTimeout(() => {
        this.$message({
          message: "已加入导出队列正在生成报表，请在导出列队中查看！",
          type: "success"
        });
        this.hidden = false;
      }, 0);
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.queryStartTime = this.isArray(searchCondition.applyDate)
        ? searchCondition.applyDate[0]
        : "";
      searchCondition.queryEndTime = this.isArray(searchCondition.applyDate)
        ? searchCondition.applyDate[1]
        : "";
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "queryStoreExamineList",
        params
      );
      if (code === "0") {
        const { total, records } = result;
        this.list = records;
        this.total = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    switchTab() {
      this.currentPage = 1;
      this.pageSize = 10;
      this.queryList();
    }
  }
};
</script>

<style scoped lang="scss">
.rejected {
  color: #ff0000;
}
.waitAudit {
  color: #0081e5;
}
.success {
  color: #2fc348;
}

.info-list {
  .title {
    color: rgba(34, 34, 34, 1);
    margin-bottom: 10px;
    &::before {
      display: inline-block;
      margin-right: 10px;
      content: "";
      width: 4px;
      height: 12px;
      background: #e50065;
      border-top-left-radius: 30px;
      border-bottom-right-radius: 30px;
    }
  }
}
.modal-table {
  border: 1px solid #ddd;
  border-radius: 5px;
  text-align: center;
  .table-header {
    background: #f7f7f7;
    font-weight: 700;
    font-size: 12px;
    > div {
      padding: 10px;
      color: #222;
    }
  }
  .table-body {
    > div {
      padding: 10px;
    }
  }
}
</style>
